import React from 'react'
import { formatLedgerRangeCitation } from '../../lib/ledgerRangeCitation'
import type { LedgerSafeHiddenWitnessRowRun } from '../../lib/ledgerSafeFilteredRowProjection'

export interface LedgerSafeFilteredRowRunProps {
  run: LedgerSafeHiddenWitnessRowRun
  visibleWitnessCount: number
  supportingWitnessLabels: string[]
  onRestoreWitnesses: (witnessIds: string[]) => void
  onRowElement: (rowIds: string[], node: HTMLTableRowElement | null) => void
}

export const LedgerSafeFilteredRowRun: React.FC<LedgerSafeFilteredRowRunProps> = ({
  run,
  visibleWitnessCount,
  supportingWitnessLabels,
  onRestoreWitnesses,
  onRowElement,
}) => {
  const witnessList = supportingWitnessLabels.join(', ')
  const restoreLabel = supportingWitnessLabels.length === 1
    ? `Show ${supportingWitnessLabels[0]}`
    : `Show ${supportingWitnessLabels.length} witnesses`

  return (
    <tr
      ref={node => onRowElement(run.rowIds, node)}
      data-testid={`ledger-filtered-row-run-${run.rowIds.join('-')}`}
      className="group bg-[#fffdfa]"
    >
      <td
        colSpan={visibleWitnessCount + 1}
        className="border-b border-black/10 bg-[#fffdfa] p-0 align-middle"
      >
        <div className="ledger-heading ledger-heading-filtered-range">
          <div className="ledger-heading-reference">{formatLedgerRangeCitation(run.firstRowLabel, run.lastRowLabel)}</div>
          <button
            type="button"
            aria-label={`${restoreLabel} and restore ${run.label}`}
            onClick={() => onRestoreWitnesses(run.supportingWitnessIds)}
            className="order-3 shrink-0 border border-black bg-black px-2 py-1 font-sans text-[9px] font-bold text-white hover:bg-gray-800"
          >
            {restoreLabel}
          </button>
          <div className="ledger-heading-content order-2">
            <div className="font-mono text-[10px] font-bold uppercase tracking-[0.16em] text-gray-500">
              — {run.rowCount} {run.rowCount === 1 ? 'row' : 'rows'} collapsed by witness filter —
            </div>
            <div className="mt-1 font-mono text-[9px] text-gray-400">
              Attested only by {witnessList}, currently filtered out. Restore {supportingWitnessLabels.length === 1 ? 'this witness' : 'these witnesses'} to show the rows at their original loci.
            </div>
          </div>
        </div>
      </td>
    </tr>
  )
}
